import { render } from "./GeneralTestingPage.vue?vue&type=template&id=ed01cdd2&scoped=true"
import script from "./GeneralTestingPage.vue?vue&type=script&lang=js"
export * from "./GeneralTestingPage.vue?vue&type=script&lang=js"

import "./GeneralTestingPage.vue?vue&type=style&index=0&id=ed01cdd2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed01cdd2"]])

export default __exports__